import {
  FormSchema,
  IFormSchema,
  OnMemoryFileRefkeyExchanger,
} from "@graffer-inc/form-schema";
import * as React from "react";
import {
  FormGeneratorV2,
  grafferSchemasSuportTagNames,
  MarkdownProcessor,
  useFormGenViewModel,
} from "@graffer-inc/form-generator";
import { addressSearchBaseUrl } from "../../../utils/postal-code/base-url";
import { formMarkdownProcessorFactory } from "../../../utils/markdown/processor";

export const SurveyFormPreview: React.FC<{
  currentFormSchema: IFormSchema;
}> = ({ currentFormSchema }) => {
  const formSubmissionContext = React.useMemo(
    () => {
      // プレビューの申請基準日は現在時とする。
      return { submissionDate: new Date() };
    },
    // フォームが変更された場合には再計算する。
    [currentFormSchema],
  );
  const [fileRefKeyExchanger] = React.useState(
    new OnMemoryFileRefkeyExchanger(),
  );

  const surveyFormSchema = FormSchema.fromJSON(currentFormSchema);

  const formProps = useFormGenViewModel({
    formSchema: surveyFormSchema,
    values: surveyFormSchema.toInitialDocument(),
    refKeyRegistry: () => ({
      ...fileRefKeyExchanger.store,
    }),
    formSubmissionContext,
  });

  const processor = formMarkdownProcessorFactory(grafferSchemasSuportTagNames);
  const surveyGrafferSchemasMarkdownProcessor: MarkdownProcessor = (
    content,
  ) => {
    return processor.processSync(content).result as React.ReactNode;
  };

  return (
    <FormGeneratorV2
      {...formProps}
      currentSection={undefined}
      refkeyContext={{
        fileRefKeyExchanger,
      }}
      submissionContext={formSubmissionContext}
      externalServiceUrlConfig={{
        corporationSearchFormBaseUrl: "", // 2023/10時点ではアンケートでの法人検索コンポーネント利用は想定・要望がないため、空文字を渡す
        addressSearchBaseUrl: addressSearchBaseUrl,
      }}
      markdownConfig={{
        markdownProcessor: surveyGrafferSchemasMarkdownProcessor,
      }}
    />
  );
};
